import React from 'react';
import { useHistory } from 'react-router-dom';
import { ERoute } from 'enums/route.enum';
import styled from 'styled-components';
import { device } from 'GlobalStyles';

type TClassList = {
  isList?: boolean;
  data?: Array<TVideo>;
};

type TVideo = {
  id: number;
  title: string;
  description: Array<{ body: string }>;
  video_number: number;
  thumbnail_image: string;
  video_url: string;
  mentor_name: string;
};

const ClassList = ({ isList, data }: TClassList) => {
  const history = useHistory();

  return (
    <StyledContainer isList={isList}>
      <h1 className='title'>강의 목록</h1>
      {data?.map((el: TVideo) => (
        <div
          className='lectures'
          onClick={() => !isList && history.push(ERoute.ExcelClassPlayer.replace(':id', String(el.id - 1)))}
        >
          <img className='lectureThumbnail' src={el.thumbnail_image} alt='thumbnail' />
          <div className='lectureInfo'>
            <div className='lectureNumberAndTime'>
              <div className='lectureNumber'>{`0${el.id}`}</div>
              <div className='info'>{el.id === 1 ? '56:34' : el.id === 2 ? '54:06' : '27:38'}</div>
            </div>
            <h2 className='lectureTitle'>{el.title}</h2>
            {el.description.map((el): any => (
              <div className='info'>{`- ${el.body}`}</div>
            ))}
          </div>
        </div>
      ))}
      {isList && (
        <div className='classInfo'>* 강의 시간 외에 실습시간은 개인 숙련도에 따라 다를 수 있습니다.</div>
      )}
    </StyledContainer>
  );
};

export default ClassList;

const StyledContainer = styled.article<TClassList>`
  max-width: 988px;
  width: ${({ isList }) => !isList && '50%'};
  margin: ${({ isList }) => (isList ? '140px auto 100px auto' : 0)};

  @media screen and ${device.lg} {
    margin: 0 auto;
    width: 80%;
  }

  .title {
    margin: 0;
    padding: ${({ isList }) => (isList ? '0 40px 40px 40px' : '0 0 23px 0')};
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    font-size: ${({ isList }) => (isList ? '40px' : '20px')};
    font-weight: 900;

    @media screen and ${device.md} {
      padding: 20px;
      font-size: 26px;
    }
  }

  .lectures {
    display: flex;
    padding: ${({ isList }) => (isList ? '40px' : '20px')};
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    cursor: ${({ isList }) => !isList && 'pointer'};

    @media screen and ${device.lg} {
      flex-direction: column;
      padding: 20px;
    }
  }

  .lectureThumbnail {
    width: ${({ isList }) => (isList ? '45%' : '50%')};
    margin-right: ${({ isList }) => (isList ? '95px' : '30px')};

    @media screen and ${device.lg} {
      width: 100%;
      margin: 0 0 20px 0;
    }
  }

  .lectureInfo {
    width: 100%;
  }

  .lectureNumberAndTime {
    display: flex;
    justify-content: space-between;
  }

  .lectureNumber {
    display: inline-block;
    margin-bottom: ${({ isList }) => (isList ? '20px' : '7px')};
    padding: ${({ isList }) => (isList ? '0 11px' : '1px 5px')};
    border-radius: 6px;
    font-size: ${({ isList }) => (isList ? '24px' : '11px')};
    color: white;
    background-color: #72ce76;

    @media screen and ${device.md} {
      margin-bottom: 7px;
      font-size: 14px;
    }
  }

  .lectureTitle {
    margin-bottom: ${({ isList }) => (isList ? '12px' : '7px')};
    font-size: ${({ isList }) => (isList ? '30px' : '14px')};
    font-weight: 900;

    @media screen and ${device.md} {
      margin-bottom: 7px;
      font-size: 18px;
    }
  }

  .info {
    font-size: ${({ isList }) => (isList ? '20px' : '10px')};
    color: rgba(0, 0, 0, 0.5);

    @media screen and ${device.md} {
      font-size: 14px;
    }
  }

  .mentor {
    margin-top: ${({ isList }) => (isList ? '10px' : '6px')};
    font-size: ${({ isList }) => (isList ? '24px' : '12px')};
    color: #000000;

    @media screen and ${device.md} {
      margin-top: 6px;
      font-size: 12px;
    }
  }

  .classInfo {
    margin-top: 5px;
    padding: 0 40px;
    color: rgba(0, 0, 0, 0.5);

    @media screen and ${device.lg} {
      padding: 0 20px;
    }
  }
`;
